import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Gender } from '@enums/gender';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { TreatmentGenderSettings } from '@models/treatment-types/treatment-gender-settings.model';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Bacterial Vaginosis treatment type.
 */
export const BacterialVaginosisTreatment = new TreatmentType({
  id: '3',
  name: ConsultationTreatmentTypes.BacterialVaginosis,
  eligibleTreatmentTypes: [
    { id: 2930, name: UpsellSlugs.ClindamycinVaginalCream },
    { id: 2931, name: UpsellSlugs.MetronidazoleVaginalGel },
  ],
  genderSettings: new TreatmentGenderSettings({
    medicationOverrides: {
      [Gender.Male]: {
        3080: 3186,
        2792: 3186,
        2800: 3186,
        2794: 3186,
        2801: 3186,
        2905: 3196,
        2904: 3196,
      },
    },
    treatmentNames: {
      [Gender.Male]: ConsultationTreatmentTypes.MaleBv,
    },
    infoMessages: {
      [Gender.Male]:
        'A licensed clinician will review your request and prescribe medication specifically recommended for treating bacterial vaginosis (BV) in men.',
    },
  }),
});
